import themeGet from '@styled-system/theme-get';
import { motion } from 'motion/react';
import { Close } from 'pcln-icons';
import styled, { css } from 'styled-components';
import { ComposedStyleFns } from '../theme/theme';
import { getPaletteColor } from '../utils/utils';
/** @public */
export const closeButtonSizes = ['sm', 'md', 'lg'];
export const closeButtonIconSizes = {
  sm: 20,
  md: 24,
  lg: 32
};
export const filledVariationSizes = {
  sm: 32,
  md: 40,
  lg: 48
};
// The following should be true to adhere to WCAG guidelines for minimum clickable size:
// 2 * closeButtonInteractionPadding + closeButtonIconSizes.sm >= 44
const clickablePaddingPx = 24;
/** @public */
export const closeButtonVariants = ['filled', 'white'];
export const closeButtonVariantProps = {
  filled: {
    bgColor: 'background.lightest',
    boxShadowSize: 'sm',
    color: 'primary.base'
  },
  white: {
    color: 'text.lightest'
  }
};
function clickableAreaCss({
  size,
  variant
}) {
  const position = variant === 'filled' ? -6 : -12;
  let heightWidthPx = (typeof size === 'number' ? size : closeButtonIconSizes[size]) + clickablePaddingPx;
  // clickable area should never be larger than 48px for named sizes
  heightWidthPx = closeButtonIconSizes[size] && heightWidthPx >= 48 ? 48 : heightWidthPx;
  return css(["&:after{content:'';position:absolute;width:", "px;height:", "px;top:-", "px;left:-", "px;}"], heightWidthPx, heightWidthPx, position, position);
}
export const MotionButton = /*#__PURE__*/styled(motion.button).withConfig({
  displayName: "CloseButtonstyled__MotionButton",
  componentId: "sc-8s6n3l-0"
})(["all:unset;", " display:grid;place-items:center;border-radius:100%;cursor:pointer;border-sizing:border-box;position:relative;box-shadow:", ";color:", ";background-color:", ";&:focus-visible{outline:2px solid ", ";}", " ", " ", ""], ComposedStyleFns, props => themeGet(`shadows.${props.boxShadowSize}`)(props), props => themeGet(`palette.${props.color}`)(props), props => themeGet(`palette.${props.bgColor}`)(props), props => themeGet(`palette.${props.color}`)(props), clickableAreaCss, ({
  variant,
  size
}) => {
  if (variant === 'filled') {
    return css(["height:", "px;width:", "px;"], filledVariationSizes[size], filledVariationSizes[size]);
  }
}, ({
  variant
}) => variant === 'filled' && css(["&:hover{box-shadow:", ";}&:hover > svg{color:", ";}"], props => themeGet(`shadows.xl`)(props), getPaletteColor('primary.dark')));
export const BackgroundAnimation = /*#__PURE__*/styled(motion.div).withConfig({
  displayName: "CloseButtonstyled__BackgroundAnimation",
  componentId: "sc-8s6n3l-1"
})(["height:125%;width:125%;background:black;border-radius:100%;mix-blend-mode:multiply;position:absolute;opacity:0.15;"]);
export const CloseIcon = /*#__PURE__*/styled(Close).withConfig({
  displayName: "CloseButtonstyled__CloseIcon",
  componentId: "sc-8s6n3l-2"
})(["width:", "px;z-index:0;border-radius:100%;"], ({
  size
}) => typeof size === 'number' ? size : closeButtonIconSizes[size]);